import Phaser from 'Phaser';
import LobbyScene from '../Lobby/LobbyScene';
// const admob = require('cordova-admob/www/admob');
import regeneratorRuntime from 'regenerator-runtime';

let $ = require( 'jquery' );

import * as classes from '../../modules/classes';
import * as colliderCallbacks from '../../modules/colliderCallbacks';
import * as ui from '../../modules/ui';
import * as challengeLevels from '../../modules/challengeLevels';
import * as utility from '../../modules/utility';
import * as userAccounts from '../../modules/userAccounts';

// Import Spine files
import workerJson from '../../assets/animations/worker.json';
import workerAtlas from '../../assets/animations/worker.txt';
import waspJson from '../../assets/animations/wasp.json';
import waspAtlas from '../../assets/animations/wasp.txt';
import foxgloveJson from '../../assets/animations/foxglove.json';
import foxgloveAtlas from '../../assets/animations/foxglove.txt';
import lavenderJson from '../../assets/animations/lavender.json';
import lavenderAtlas from '../../assets/animations/lavender.txt';
import strawberryJson from '../../assets/animations/strawberry.json';
import strawberryAtlas from '../../assets/animations/strawberry.txt';
import echinaceaJson from '../../assets/animations/echinacea.json';
import echinaceaAtlas from '../../assets/animations/echinacea.txt';
import treeJson from '../../assets/animations/tree.json';
import treeAtlas from '../../assets/animations/tree.txt';

// Import sound files
import beeBuzz1 from '../../assets/audio/beeBuzz1.mp3';
import beeBuzz2 from '../../assets/audio/beeBuzz2.mp3';
import beeBuzz3 from '../../assets/audio/beeBuzz3.mp3';
import beeBuzz4 from '../../assets/audio/beeBuzz4.mp3';
import beeBuzz5 from '../../assets/audio/beeBuzz5.mp3';
import beeBuzz6 from '../../assets/audio/beeBuzz6.mp3';

class GameScene extends Phaser.Scene {
  constructor() {
    super({ key: 'Game' });
  }

  preload()
  {

        // Remove Lobby Scene
        this.scene.manager.stop('Lobby');

        // Hide Main MENU
        var mainMenu = document.getElementById('mainMenu');
        mainMenu.hidden = true;

        // // Define Variables and Arrays // //

        this.worldWidth  = 4000;
        this.worldHeight = 4000;

        this.numberOfQueenBeeBots = 1;
        this.numberOfGreenSpaces = 9;
        this.numberOfLogs = 5;
        this.numberOfBoulders = 5;
        this.numberOfPonds = 3;
        this.numberOfTrees = 5;
        this.numberOfStarterHives = 2;

        this.queenBees = [];
        this.queenSpawnRate = 10000;
        this.queenBeesGroup = this.physics.add.group();
        this.queenBeeEggLaysGroup = this.physics.add.group();
        this.queenBeeBotsGroup = this.physics.add.group();
        this.queenBeeGlowsGroup = this.physics.add.group();
        this.botBeeSpecies = [
            'bumbleBee',
            'sweat',
            'catBee',
            'blueBee',
            'violetBee',
            'crown',
            'gasMask',
            'horns',
            'partyHat',
            'fedora',
            'threeCorneredHat',
            'wizardHat',
            'knight'
        ];

        this.workers = [];
        this.workersGroup = this.physics.add.group();
        this.workerRoles = ['forager', 'nurse', 'builder'];
        this.workerSelectionSpritesGroup = this.physics.add.group();
        this.numberOfLocalWorkers = 0;
        this.numberOfStarterWorkers = 3;
        this.workerHealRate = 2000;
        this.workerHealAmount = 5;
        this.workerAggroRange = 500;
        this.corpseFadeTime = 20000;
        this.melliferaQueenSpeed = 200;
        this.melliferaWorkerSpeed = 100;
        this.bumbleQueenSpeed = 175;
        this.bumbleWorkerSpeed = 75;
        this.workerScaleInDuration = 1000;

        this.drones = [];
        this.dronesGroup = this.physics.add.group();

        this.hives = [];
        this.hivesGroup = this.physics.add.group();
        this.cells = [];
        this.cellsGroup = this.physics.add.group();
        this.cellsThatCanBeBuiltUponVerticallyGroup = this.physics.add.group();
        this.cellsThatCanBeBuiltUponToTheLeftGroup = this.physics.add.group();
        this.cellsThatCanBeBuiltUponToTheRightGroup = this.physics.add.group();

        this.broods = [];
        this.broodsGroup = this.physics.add.group();

        this.greenSpaces = [];
        this.greenSpacesGroup = this.physics.add.group();

        this.plants = [];
        this.plantsGroup = this.physics.add.group();
        this.speciesOfPlant = ['lavender', 'strawberry', 'foxglove', 'echinacea'];

        this.logs = [];
        this.logsGroup = this.physics.add.group();

        this.boulders = [];
        this.bouldersGroup = this.physics.add.group();
        this.boulderSprites = ['boulder1.png', 'boulder2.png', 'boulder3.png', 'boulder4.png', 'boulder5.png', 'boulder6.png'];

        this.ponds = [];
        this.pondsGroup = this.physics.add.group();

        this.trees = [];
        this.treesGroup = this.physics.add.group();

        this.pollens = [];
        this.pollensGroup = this.physics.add.group();

        this.honeys = [];
        this.honeysGroup = this.physics.add.group();

        this.beeBreads = [];
        this.beeBreadsGroup = this.physics.add.group();

        this.wasps = [];
        this.waspsGroup = this.physics.add.group();
        this.numberOfStarterGiantWasps = 0;
        this.numberOfWaspsPerSpawn = 1;
        this.waspSpawnRate = (1000 * 60) * 5; // five minutes
        // this.waspSpawnRate = 10000; // ten seconds
        // this.waspSpawnRate = 1000; // one second

        this.yellowJackets = [];
        this.yellowJacketsGroup = this.physics.add.group();
        this.numberOfStarterYellowJackets = 0;
        this.numberOfYellowJacketsPerSpawn = 1;
        this.yellowJacketSpawnRate = (1000 * 60) * 3; // three minutes
        // this.yellowJacketSpawnRate = (1000 * 10); // ten seconds
        // this.yellowJacketSpawnRate = 1000; // one second
        this.yellowJacketHivesGroup = this.physics.add.group();

        this.varroaMites = []
        this.varroaMitesGroup = this.physics.add.group();
        // this.varroaMiteSpawnRate = (1000 * 60) * 2; // two minutes
        this.varroaMiteSpawnRate = (1000 * 90); // one and a half minutes
        // this.varroaMiteSpawnRate = 60000; // one minute
        // this.varroaMiteSpawnRate = 500; // half a second

        this.objectUpdateRate = 25;

        this.cursors;
        this.fadeCamera;
        this.cameraArray = [];

        this.uiGroup = this.physics.add.group();
        this.actionButtons = this.physics.add.group();
        this.buttonsScaledDown = false;
        this.mobileWidth = 550; // The max width we'll consider a screen mobile.
        this.mobileActionButtonScale = .80; // The percentage of the size from normal that action buttons will be on mobile.

        // Settings
        this.storedSoundDisabled = localStorage.getItem('storedSoundDisabled');
        if (this.storedSoundDisabled == 'false' ||
            this.storedSoundDisabled == null)
        {
            this.enableSound = true;
        } else {
            this.enableSound = false;
        }

        this.storedAnimationsDisabled = localStorage.getItem('storedAnimationsDisabled');
        if (this.storedAnimationsDisabled == 'false' ||
            this.storedAnimationsDisabled == null)
        {
            this.enableSpine = true;
        } else {
            this.enableSpine = false;
        }

        this.enableFPSCounter = false;

        // UI Variables
        this.virtualJoystickEnabled = localStorage.getItem('virtualJoystickEnabled');
        this.messageBoxes = [];
        this.messageText = [
            'Press and hold where you would like to go, and the queen bee will head there.',
            'Place a hive with the New Hive button (Hotkey: 2).',
            'Press a nearby hive cell to select it. Place eggs in it with the Lay Egg button (Hotkey: 3).',
            'Press one of your worker bees to select them. Choose one of three jobs that appear below them.',
            'Foragers collect pollen and nectar from flowers and bring it back to the hive.',
            'Nurses gather collected pollen bee bread and feed it to your larva, beginning their transition into full-grown workers.',
            'When a full grown worker emerges, it will belong to the nearest queen bee.',
            'Builders eat honey and build new cells into the hive.',
            'Press Attack to toggle alarm pheromones (Hotkey: 4). Your workers will begin attacking nearby rival bees, mites, and wasps.',
            'Varroa mites are parasitic insects which will hitch a ride on your workers to your brood where they will kill them and reproduce.',
            'Nurse bees will groom mites off other workers. You could also use Attack to have your workers kill nearby mites.',
            'Clicking Eat Honey will heal the queen a little.',
            'If logged in with a player account, clicking Eat Honey will add it to your account. Honey can be used to purchase new playable bee species and perks.',
            'Press the question mark icon to close this box.'
        ];
        this.messageBoxSelected = 0;
        if (this.virtualJoystickEnabled == 'true')
        {
            this.messageText[0] = 'Use the virtual joystick in the bottom-right of the screen to control the queen bee.';
        }

        // Challenge Variables
        this.metric;
        this.goal;
        this.goal2;
        this.challengeConcluded = false;
        this.challengeFail = false;
        this.scoreTexts = [];

        // Multiplayer variables
        this.isMultiplayer = null;
        this.client = {};
        this.username = 'player';
        this.colonyName = 'player';
        this.beeSendRate = 250;
        this.workerCountSprites = [];
        this.scoreUsernameTexts = [];
        this.rightToHost = true;

        // Load Spine animations
        this.load.spine('worker', workerJson, workerAtlas);
        this.load.spine('wasp', waspJson, waspAtlas);
        this.load.spine('foxglove', foxgloveJson, foxgloveAtlas);
        this.load.spine('lavender', lavenderJson, lavenderAtlas);
        this.load.spine('strawberry', strawberryJson, strawberryAtlas);
        this.load.spine('echinacea', echinaceaJson, echinaceaAtlas);
        this.load.spine('tree', treeJson, treeAtlas);

        // Load Sounds
        this.load.audio('beeBuzz1', beeBuzz1);
        this.load.audio('beeBuzz2', beeBuzz2);
        this.load.audio('beeBuzz3', beeBuzz3);
        this.load.audio('beeBuzz4', beeBuzz4);
        this.load.audio('beeBuzz5', beeBuzz5);
        this.load.audio('beeBuzz6', beeBuzz6);

        utility.addPluginsToScene(this);
  }

  create(data)
  {
        // User data sent from LobbyScene.
        if (data[0])
        {
            this.userData = data[0];
        } else {
            this.userData = {};
        }

        if (data[1])
        {
            this.selectedSpecies = data[1];
            this.client.selectedSpecies = this.selectedSpecies;
            this.uid = data[0].uid;
        }

        if (data[2] &&
            data[2] != '0')
        {
            this.levelData = data[2];
            this.level = Number(this.levelData.level);
        } else {
            this.level = 0;
        }

        ui.addUI(this);

        this.physics.world.setBounds(
            -(this.worldWidth/2), -(this.worldHeight/2),
             this.worldWidth, this.worldHeight
         );

        // Define keyboard keys.
        this.defineKeyboardKeys(this);

        this.scale.on('resize', ui.resizeScene, this);

        // Texture
        var backgroundTextureSprite = this.add.tileSprite(0, 0, this.physics.world.bounds.width, this.physics.world.bounds.height, 'sprites', 'dustAndScratches.png');
        backgroundTextureSprite.alpha = 1;

        // Switch between sandbox or challenge modes.
        switch (this.level)
        {
            case 0:
                this.loadSandboxSetup(this).then(() => {
                    console.log('Got sandbox setup.');
                    this.placeMapObjects(this);
                });
                break;
            default:
                challengeLevels.loadChallengeSetup(this);
                console.log('Got challenge setup for level ', this.level, '.');
                this.placeMapObjects(this);
                challengeLevels.initializeChallengeLevel(this);
                break;
        }

        var updateObjectsEvent = this.time.addEvent(
        {
            delay: this.objectUpdateRate,
            callback: this.updateObjects,
            callbackScope: this,
            loop: true
        });

        // Add HP to workers over time.
        var workersHealEvent = this.time.addEvent(
        {
            delay: this.workerHealRate,
            callback: this.workersHeal,
            callbackScope: this,
            loop: true
        });

        // Check distance between queen and nearest cell
        // and deactivate new hive button if too near.
        var checkDistanceToClosestCellFromQueenEvent = this.time.addEvent(
        {
            delay: 500,
            callback: this.checkDistanceToClosestCellFromQueen,
            callbackScope: this,
            loop: true
        });

        this.addCollidersToGroups(this);

        utility.setDepthOfGroups(this);

        ui.inGameMenuButtons(this);

        if (this.enableFPSCounter)
        {
            this.fpsText = this.add.text(10, 10, 'FPS : 0', {fontSize: 30, color: '#ffffff', align: 'left'})
            this.fpsText.setScrollFactor(0);
            this.uiGroup.add(this.fpsText);
            this.lastUpdateTime = 0;
            this.counter = 0;
        }

    }

    defineKeyboardKeys(scene)
    {
        scene.cursors = scene.input.keyboard.createCursorKeys();
        scene.oneKey = scene.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.ONE);
        scene.twoKey = scene.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.TWO);
        scene.threeKey = scene.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.THREE);
        scene.fourKey = scene.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.FOUR);
        scene.fiveKey = scene.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.FIVE);
        scene.wKey = scene.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.W);
        scene.aKey = scene.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.A);
        scene.sKey = scene.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.S);
        scene.dKey = scene.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.D);
    }

    async loadSandboxSetup(scene)
    {
        try {
            if (localStorage.getItem('numberOfSandboxQueenBeeBots'))
            {
                this.numberOfQueenBeeBots = Number( localStorage.getItem('numberOfSandboxQueenBeeBots') );
            }
            if (localStorage.getItem('numberOfSandboxGreenSpaces'))
            {
                this.numberOfGreenSpaces = Number( localStorage.getItem('numberOfSandboxGreenSpaces') );
            }
            if (localStorage.getItem('numberOfSandboxLogs'))
            {
                this.numberOfLogs = Number( localStorage.getItem('numberOfSandboxLogs') );
            }
            if (localStorage.getItem('numberOfSandboxBoulders'))
            {
                this.numberOfBoulders = Number( localStorage.getItem('numberOfSandboxBoulders') );
            }
            if (localStorage.getItem('numberOfSandboxPonds'))
            {
                this.numberOfPonds = Number( localStorage.getItem('numberOfSandboxPonds') );
            }
            if (localStorage.getItem('numberOfSandboxTrees'))
            {
                this.numberOfTrees = Number( localStorage.getItem('numberOfSandboxTrees') );
            }
            if (localStorage.getItem('numberOfSandboxStarterHives'))
            {
                this.numberOfStarterHives = Number( localStorage.getItem('numberOfSandboxStarterHives') );
            }

            let storedWaspSpawn = localStorage.getItem('waspSpawnCheck');
            switch(storedWaspSpawn)
            {
                case 'false':
                    this.yellowJacketSpawnRate = 1000000000000000000;
                    this.waspSpawnRate =         1000000000000000000;
                    break;
                default:
                    this.yellowJacketSpawnRate = (1000 * 60) * 3;
                    this.waspSpawnRate =         (1000 * 60) * 5; // five minutes
            }
        } catch(e) {
        	console.log("There was an error loading sandback setup: ", e);
        }
    }

    pickARandomBeeSpecies(scene)
    {
        // // Randomly select a bot species that isn't the player's specie.
        let botSpecies = Phaser.Math.RND.pick(scene.botBeeSpecies);
        for (let specie of this.botBeeSpecies)
        {
            // console.log('Rerolling botBeeSpecies: ', specie);
            if (specie == botSpecies &&
                specie == scene.selectedSpecies)
            {
                botSpecies = Phaser.Math.RND.pick(scene.botBeeSpecies);
            } else {
                return botSpecies;
            }
        }
    }

    // Setup map with game objects.
    placeMapObjects(scene)
    {
        // // Place player // //
        var x = 0;
        var y = 0;
        var player;
        var colonyName = this.selectedSpecies;
        this.queenBees.push( player = new classes.QueenBees(
            this,
            x,
            y,
            this.username,
            colonyName,
            this.selectedSpecies) );



        this.minimapCamera.startFollow(player.queenBeeSprite);
        this.cameras.main.startFollow(player.queenBeeSprite);
        this.cameras.main.setBackgroundColor('rgba(191,175,153,1)');

        // // Place Static Objecs // //

        // Green Spaces
        for (var i = 0; i < scene.numberOfGreenSpaces; i++)
        {

            var x = Phaser.Math.RND.integerInRange(-(scene.worldWidth/2),scene.worldWidth/2);
            var y = Phaser.Math.RND.integerInRange(-(scene.worldHeight/2),scene.worldHeight/2);
            var angle = Phaser.Math.RND.integerInRange(0,360);
            scene.greenSpaces.push( new classes.GreenSpaces(scene, x, y, angle, null, scene.username) );
        }

        // Logs
        for (var i = 0; i < scene.numberOfLogs; i++)
        {
            var x = Phaser.Math.RND.integerInRange(-(scene.worldWidth/2),scene.worldWidth/2);
            var y = Phaser.Math.RND.integerInRange(-(scene.worldHeight/2),scene.worldHeight/2);
            var angle = Phaser.Math.RND.integerInRange(0,360);
            scene.logs.push( new classes.Logs(scene, x, y, angle, scene.username) );
        }

        // Boulders
        for (var i = 0; i < scene.numberOfBoulders; i++)
        {
            var x = Phaser.Math.RND.integerInRange(-(scene.worldWidth/2),scene.worldWidth/2);
            var y = Phaser.Math.RND.integerInRange(-(scene.worldHeight/2),scene.worldHeight/2);
            var angle = Phaser.Math.RND.integerInRange(0,360);
            scene.boulders.push( new classes.Boulders(scene, x, y, angle, scene.username) );
        }

        // Ponds
        for (var i = 0; i < scene.numberOfPonds; i++)
        {

            var x = Phaser.Math.RND.integerInRange(-(scene.worldWidth/2),scene.worldWidth/2);
            var y = Phaser.Math.RND.integerInRange(-(scene.worldHeight/2),scene.worldHeight/2);
            var angle = Phaser.Math.RND.integerInRange(0,360);
            scene.ponds.push( new classes.Ponds(scene, x, y, angle, scene.username) );
        }

        // Trees
        for (var i = 0; i < scene.numberOfTrees; i++)
        {

            var x = Phaser.Math.RND.integerInRange(-(scene.worldWidth/2),scene.worldWidth/2);
            var y = Phaser.Math.RND.integerInRange(-(scene.worldHeight/2),scene.worldHeight/2);
            var angle = Phaser.Math.RND.integerInRange(0,360);
            scene.trees.push( new classes.Trees(scene, x, y, angle, scene.username) );
        }

        // Hives
        for(var i = 0; i < scene.numberOfStarterHives; i++)
        {
            var x = Phaser.Math.RND.integerInRange(-(scene.worldWidth/2),scene.worldWidth/2);
            var y = Phaser.Math.RND.integerInRange(-(scene.worldHeight/2),scene.worldHeight/2);
            scene.hives.push( new classes.Hives(scene, x, y) );
        }

        // // Place Mobs // //

        // Workers
        for (var i = 0; i < this.numberOfStarterWorkers; i++)
        {
            var x = Phaser.Math.RND.integerInRange(-1500,1500);
            var y = Phaser.Math.RND.integerInRange(-1500,1500);
            this.workers.push( new classes.Workers(
                this,
                x,
                y,
                this.username,
                this.workers.length,
                this.colonyName,
                this.queenBees[0].species
            ) );
        }

        // Place starter queen bee bots
        for (var i = 0; i < this.numberOfQueenBeeBots; i++)
        {
            // Spawn bot
            let botUserName = 'Bot' + i;
            let botColonyName = 'Bot' + i;
            let botSpecies = this.pickARandomBeeSpecies(this);
            // console.log('bot species', botSpecies);
            let randomX = Phaser.Math.RND.integerInRange(-600, 600);
            let randomY = Phaser.Math.RND.integerInRange(-600, 600);
            utility.spawnQueenBeeBot(this, randomX, randomY, botUserName, botColonyName, botSpecies);

            // Workers
            for (var j = 0; j < this.numberOfStarterWorkers; j++)
            {
                var x = Phaser.Math.RND.integerInRange(-1500,1500);
                var y = Phaser.Math.RND.integerInRange(-1500,1500);
                this.workers.push( new classes.Workers(this, x, y, botUserName, this.workers.length, botColonyName, botSpecies) );
            }
        }

        // Drone
        // this.drones.push( new Drones(this, this.queenBees[0].queenBeeSprite.x, this.queenBees[0].queenBeeSprite.y, this.client.username, this.drones.length) );

        // Set worker selection sprites invisible
        var childrenWorkerSelectionSprites = this.workerSelectionSpritesGroup.getChildren();
        for (var i = 0; i < childrenWorkerSelectionSprites.length; i++)
        {
            childrenWorkerSelectionSprites[i].alpha = 0;
        }

        // Wasps
        for (let j = 0; j < this.numberOfStarterGiantWasps; j++)
        {
            var x = Phaser.Math.RND.integerInRange(-1500,1500);
            var y = Phaser.Math.RND.integerInRange(-1500,1500);
            this.wasps.push( new classes.Wasps(this, x, y, this.username, this.wasps.length) );
        }
        // Start the wasp spawner.
        var createWaspEvent = scene.time.addEvent(
        {
            delay: scene.waspSpawnRate,
            callback: scene.waspSpawner,
            callbackScope: scene,
            loop: true
        });

        // Yellow Jackets
        for (let j = 0; j < this.numberOfStarterYellowJackets; j++)
        {
            var x = Phaser.Math.RND.integerInRange(-1500,1500);
            var y = Phaser.Math.RND.integerInRange(-1500,1500);
            this.yellowJackets.push( new classes.YellowJackets(this, x, y, this.username, this.yellowJackets.length) );
        }
        // Start the yellow jacket spawner.
        scene.createYellowJacketEvent = scene.time.addEvent(
        {
            delay: scene.yellowJacketSpawnRate,
            callback: scene.yellowJacketSpawner,
            callbackScope: scene,
            loop: true
        });

        // Varroa Mites
        // Start the varroa mite spawner.

        var createVarroaMiteEvent = scene.time.addEvent(
        {
            delay: scene.varroaMiteSpawnRate,
            callback: scene.varroaMiteSpawner,
            callbackScope: scene,
            loop: true
        });

        utility.setDepthOfGroups(scene);
    }

    addCollidersToGroups(scene)
    {
        scene.colliders = {};
        // Workers Collide on stuff.
        scene.physics.add.collider(scene.workersGroup, scene.workersGroup, colliderCallbacks.workerTouchedWorker);
        scene.physics.add.collider(scene.workersGroup, scene.queenBeesGroup, colliderCallbacks.workerTouchedQueenBee);
        scene.physics.add.collider(scene.workersGroup, scene.waspsGroup, colliderCallbacks.workerTouchedWasp);
        scene.physics.add.collider(scene.workersGroup, scene.yellowJacketsGroup, colliderCallbacks.workerTouchedYellowJacket);
        scene.physics.add.collider(scene.workersGroup, scene.varroaMitesGroup, colliderCallbacks.workerTouchedVarroaMite);
        scene.physics.add.overlap(scene.workersGroup, scene.dronesGroup);
        scene.colliders.workerTouchedPlantOverlap = scene.physics.add.overlap(scene.workersGroup, scene.plantsGroup, colliderCallbacks.workerTouchedPlant);
        scene.physics.add.overlap(scene.workersGroup, scene.hivesGroup, colliderCallbacks.workerTouchedHive);
        scene.physics.add.collider(scene.workersGroup, scene.pollensGroup, colliderCallbacks.beeTouchedPollen);
        scene.physics.add.overlap(scene.workersGroup, scene.cellsGroup, colliderCallbacks.workerTouchedCell);
        scene.physics.add.overlap(scene.workersGroup, scene.beeBreadsGroup, colliderCallbacks.beeTouchedBeeBread);
        scene.physics.add.overlap(scene.workersGroup, scene.honeysGroup, colliderCallbacks.workerTouchedHoney);
        scene.physics.add.overlap(scene.workersGroup, scene.broodsGroup, colliderCallbacks.workerTouchedBrood);
        scene.physics.add.overlap(scene.workersGroup, scene.cellsThatCanBeBuiltUponVerticallyGroup, colliderCallbacks.workerTouchedCellThatCanBeBuiltUponVertically);
        scene.physics.add.overlap(scene.workersGroup, scene.cellsThatCanBeBuiltUponToTheRightGroup, colliderCallbacks.workerTouchedCellThatCanBeBuiltUponToTheRight);
        scene.physics.add.overlap(scene.workersGroup, scene.cellsThatCanBeBuiltUponToTheLeftGroup, colliderCallbacks.workerTouchedCellThatCanBeBuiltUponToTheLeft);
        scene.physics.add.collider(scene.waspsGroup, scene.waspsGroup);

        // scene.physics.add.collider(scene.dronesGroup, scene.dronesGroup);
        // Wasps eat brood.
        scene.physics.add.overlap(scene.waspsGroup, scene.broodsGroup, colliderCallbacks.waspTouchedBrood);
        // Queen bees collide on stuff.
        scene.physics.add.collider(scene.queenBeesGroup, scene.queenBeesGroup, colliderCallbacks.queenBeeTouchedQueenBee);
        scene.physics.add.collider(scene.queenBeesGroup, scene.waspsGroup);
        scene.physics.add.collider(scene.queenBeesGroup, scene.yellowJacketsGroup);
        scene.physics.add.collider(scene.queenBeesGroup, scene.varroaMitesGroup);
        scene.physics.add.collider(scene.queenBeesGroup, scene.dronesGroup);
        scene.physics.add.overlap(scene.queenBeeBotsGroup, scene.cellsGroup, colliderCallbacks.queenBeeBotTouchedCell);
        scene.physics.add.collider(scene.queenBeesGroup, scene.pollensGroup, colliderCallbacks.beeTouchedPollen);
        scene.physics.add.overlap(scene.queenBeesGroup, scene.beeBreadsGroup, colliderCallbacks.beeTouchedBeeBread);
        scene.physics.add.overlap(scene.queenBeesGroup, scene.plantsGroup, colliderCallbacks.workerTouchedPlant);
        scene.physics.add.overlap(scene.queenBeesGroup, scene.cellsGroup, colliderCallbacks.workerTouchedCell);
        scene.physics.add.collider(scene.queenBeesGroup, scene.varroaMitesGroup, colliderCallbacks.queenBeeTouchedVarroaMite);
        scene.physics.add.collider(scene.queenBeesGroup, scene.waspsGroup, colliderCallbacks.queenBeeTouchedWasp);
        scene.physics.add.collider(scene.queenBeesGroup, scene.yellowJacketsGroup, colliderCallbacks.queenBeeTouchedYellowJacket);
        // Pollens collide with each other.
        scene.physics.add.collider(scene.pollensGroup, scene.pollensGroup);
        // Bee breads collide with each other.
        scene.physics.add.collider(scene.beeBreadsGroup, scene.beeBreadsGroup);
        // Bee bread feeds brood.
        scene.physics.add.overlap(scene.beeBreadsGroup, scene.broodsGroup, colliderCallbacks.beeBreadTouchedBrood);
        // Cells kill each other so they don't overlap.
        scene.physics.add.overlap(scene.cellsGroup, scene.cellsGroup, colliderCallbacks.cellTouchedCell);
        // Varroa Mites Infects Brood
        scene.physics.add.overlap(scene.varroaMitesGroup, scene.broodsGroup, colliderCallbacks.varroaMiteTouchedBrood);
        // YellowJackets collide with stuff.
        scene.physics.add.collider(scene.yellowJacketsGroup, scene.yellowJacketsGroup);
        scene.physics.add.collider(scene.yellowJacketsGroup, scene.waspsGroup, colliderCallbacks.yellowJacketTouchedWasp);
        scene.physics.add.overlap(scene.yellowJacketsGroup, scene.broodsGroup, colliderCallbacks.yellowJacketTouchedBrood);
        scene.physics.add.overlap(scene.yellowJacketsGroup, scene.cellsGroup, colliderCallbacks.yellowJacketTouchedCell);
        scene.physics.add.overlap(scene.yellowJacketsGroup, scene.yellowJacketHivesGroup, colliderCallbacks.yellowJacketTouchedYellowJacketHive);
        // Plants are destroyed by ponds
        let plantPondCollider = scene.physics.add.overlap(scene.pondsGroup, scene.plantsGroup, colliderCallbacks.pondTouchedPlant);
        setTimeout(function() {
            scene.physics.world.removeCollider(plantPondCollider);
        }, 10);
    }

    restartScene(scene)
    {
        scene.yellowJacketHive = null;
        scene.scene.restart();
    }

    returnToLobby(scene)
    {
        try {
            if (scene.client.socket)
            {
                scene.leaveMatch(scene.client);
            }

            scene.sound.stopAll();

            document.getElementById('login').innerHTML = 'Login';

            console.log('Return to Lobby function invoked.', scene);
            scene.scene.start('Lobby');

            // Stop Game Scene
            scene.scene.manager.stop('Game');

            utility.showInterstitialAd();

        } catch(err) {
            console.log('Error while returning to lobby.', err);
        }
    }

  yellowJacketPupaBecomesYellowJacket(scene, pupa)
  {
      try
      {
          scene.yellowJackets.push(
              new classes.YellowJackets
              (
                  scene,
                  pupa.x, pupa.y,
                  null,
                  scene.yellowJackets.length
              )
          );
          challengeLevels.tallyNumberOfYellowjacketsScores(scene);

          utility.setDepthOfGroups(scene);

          // Destroy pupa
          if (pupa.birthCell)
          {
              pupa.birthCell.typeOfCell = 'empty';
          }
          pupa.broodStage = null;

      } catch (e) {
          console.log('There was an error when yellowjacket pupa became yellow jacket:', e);
      }



  }

  // Spawners
  waspSpawner()
  {
      // Tally all living wasps. Only spawn a new one if none are alive.
      let numberOfLivingWasps = 0;
      for (let i=0; i < this.wasps.length; i++)
      {
          if (this.wasps[i].waspSprite.active)
          {
              numberOfLivingWasps += 1;
          }
      }
      if (numberOfLivingWasps == 0)
      {
          for (let j = 0; j < this.numberOfWaspsPerSpawn; j++)
          {
              var x = Phaser.Math.RND.integerInRange(-1500,1500);
              var y = Phaser.Math.RND.integerInRange(-1500,1500);
              this.wasps.push( new classes.Wasps(this, x, y, this.username, this.wasps.length) );
          }
      }
  }

  yellowJacketSpawner()
  {
      if (this.levelData &&
          this.levelData.numberOfYellowJacketsPerSpawn)
      {
          this.numberOfYellowJacketsPerSpawn = this.levelData.numberOfYellowJacketsPerSpawn;
      }
      for (let j = 0; j < this.numberOfYellowJacketsPerSpawn; j++)
      {
          var x = Phaser.Math.RND.integerInRange(-1500,1500);
          var y = Phaser.Math.RND.integerInRange(-1500,1500);
          this.yellowJackets.push( new classes.YellowJackets(this, x, y, this.username, this.yellowJackets.length) );
      }
      challengeLevels.tallyNumberOfYellowjacketsScores(this);
  }

  varroaMiteSpawner() {
      var x = Phaser.Math.RND.integerInRange(-1500,1500);
      var y = Phaser.Math.RND.integerInRange(-1500,1500);
      this.varroaMites.push( new classes.VarroaMites(this, x, y, this.client.username, this.varroaMites.length) );
  }

  gameOver(scene)
  {
      console.log("All workers have perished, or the queen didn't make it. Game Over.");

      // ui.disableUI(scene);

      scene.returnToLobby(scene);

      // Unhide main menu.
      var mainMenu = document.getElementById('mainMenu');
      mainMenu.hidden = false;

      // Show alert
      let gameOverAlert = document.getElementById('gameOverAlert');
      let gameOverAlertText = document.getElementById('gameOverAlertText');
      gameOverAlertText.innerText = 'Ooh that stings, your queen died.';
      document.getElementById('gameOverAlert').classList.add('show');
      // Allow them to close the alert.
      var closeGameOverAlertButton;
      closeGameOverAlertButton = document.getElementById('closeGameOverAlertButton');
      closeGameOverAlertButton.onclick = function() {
          document.getElementById('gameOverAlert').classList.remove('show');
          console.log('Clicked close button.');
      }

  }

  update()
  {
      try {

          if (this.enableFPSCounter)
          {
              let currTime = Date.now();
              this.counter++;
              if (currTime > this.lastUpdateTime + 1000) {
                  this.lastUpdateTime = currTime;
                  this.fpsText.setText('FPS : '+ this.counter);
                  this.counter = 0;
              }
          }

          // Number keys toggle buttons.
          if (Phaser.Input.Keyboard.JustDown(this.oneKey))
          {
              ui.swarmButtonToggle(this);
          }

          if (Phaser.Input.Keyboard.JustDown(this.twoKey))
          {
              ui.newHiveButtonToggle(this);
          }

          if (Phaser.Input.Keyboard.JustDown(this.threeKey))
          {
              ui.layEggButtonToggle(this);
          }

          if (Phaser.Input.Keyboard.JustDown(this.fourKey))
          {
              ui.attackButtonToggle(this);
          }

          if (Phaser.Input.Keyboard.JustDown(this.fiveKey))
          {
              this.eatHoneyButtonToggle(this);
          }

          // Deal with hiding buttons based on queen distance.
          if (this.selectedEggLayCell)
          {
              var distanceBetween = Phaser.Math.Distance.Between(
                  this.selectedEggLayCell.x,
                  this.selectedEggLayCell.y,
                  this.queenBees[0].queenBeeSprite.x,
                  this.queenBees[0].queenBeeSprite.y);

              // Empty cells
              if (
                  distanceBetween > 250 &&
                  this.selectedEggLayCell.typeOfCell == 'empty' &&
                  this.layEggButton.isShrinking == false &&
                  this.layEggButton.isShrunk == false)
              {
                  ui.shrinkButton(this.layEggButton);
              } else if (
                  distanceBetween <= 250 &&
                  this.selectedEggLayCell.typeOfCell == 'empty' &&
                  this.layEggButton.isExpanded == false &&
                  this.layEggButton.isExpanding == false)
              {
                  ui.expandButton(this.layEggButton);
              }

          }

          // Eat Honey button expand/shrink
          try {
              if (!this.queenBees[0]) return;
              let closestHoney = utility.closestHoney(this, this.queenBees[0].queenBeeSprite);
              if (closestHoney)
              {
                  var distanceBetween = Phaser.Math.Distance.Between(
                      closestHoney.x,
                      closestHoney.y,
                      this.queenBees[0].queenBeeSprite.x,
                      this.queenBees[0].queenBeeSprite.y);
                  // Honey cells
                  if (distanceBetween > 250)
                  {
                      ui.shrinkButton(this.eatHoneyButton);
                  } else if (
                      distanceBetween <= 250 &&
                      this.eatHoneyButton.isExpanded == false &&
                      this.eatHoneyButton.isExpanding == false)
                  {
                      ui.expandButton(this.eatHoneyButton);
                  }
              } else {
                  // Hide button if no honey exists.
                  ui.shrinkButton(this.eatHoneyButton);
              }
          } catch (error) {
              console.log('There was an error updating eat honey button.', error);
          }

      } catch (e) {
          console.log('There was an error updating:', e);
      }
  }

  workersHeal()
  {
      try {
          this.workers.forEach(function(worker)
          {
              // Only heal if worker is alive.
              if (worker.workerSprite.active == true && worker.workerSprite.hitPoints < 100)
              {
                  worker.healthChange(worker, 'heal', worker.scene.workerHealAmount);
                  console.log('Worker healed.');
              }
          });
      } catch (e) {
          console.log('There was an error with workers healing:', e);
      }
  }

  updateObjects()
  {
      try {
          this.queenBees.forEach(function(queenBee)
          {
              queenBee.update(queenBee);
          });

          this.workers.forEach(function(worker)
          {
              // Only update if worker is alive.
              if (worker.workerSprite.active == true)
              {
                  worker.update(worker);
              }
          });

          this.drones.forEach(function(drone)
          {
              // Only update if drone is alive.
              if (drone.droneSprite.active == true)
              {
                  drone.update(drone);
              }
          });

          this.wasps.forEach(function(wasp)
          {
              // Only update if wasp is alive.
              if (wasp.waspSprite.active == true)
              {
                  wasp.update(wasp);
              }
          });

          this.yellowJackets.forEach(function(yellowJacket)
          {
              // Only update if yellowJacket is alive.
              if (yellowJacket.yellowJacketSprite.active == true)
              {
                  yellowJacket.update(yellowJacket);
              }
          });

          this.varroaMites.forEach(function(varroaMite)
          {
              // Only update if drone is alive.
              if (varroaMite.varroaMiteSprite.active == true)
              {
                  varroaMite.update(varroaMite);
              }
          });
      } catch (e) {
          console.log('There was an error updating objects: ', e);
      }
  }

}

export default GameScene;



// WEBPACK FOOTER //
// ./src/scenes/Game/GameScene.js